// extracted by mini-css-extract-plugin
module.exports = {"ctaText":"_3Jedet0f","title":"_2uMJG3w_","intro":"_3Z5eQS_4","ctaBtn":"gWGURwgn"};